import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { ORIENTATION_TYPE_OPTION_IDS, IMAGE_TEXT_DROPDOWN_OPTION_IDS } from 'commons/constants';
import { customItem, readyToShipItem, decideLaterItem } from 'components/consumer/PDP/PDPShopTabsBar/itemContent';
import getEnvValue from 'commons/getEnvValue';
import useScreen from 'hooks/useScreen';
import usePdpSelectedCustomizerTab from 'components/consumer/PDP/state/pdpSelectedCustomizerTab/usePdpSelectedCustomizerTab';
import SuspenseWithLoader from 'components/consumer/SuspenseWithLoader';
import PDPSelectionAlert from './PDPSelectionAlert/PDPSelectionAlert';
import PDPSelectUpholsteryInner from '../PDPSelectUpholstery';
import PDPImageSelector from '../PDPImageSelector';
import PDPImageAndTextSelector from '../PDPImageAndTextSelector';
import PDPTextDropdownOptionGroup from '../PDPTextDropdownOptionGroup';
import PDPImageTextDropdownOption from '../PDPImageTextDropdownOption';
import PDPUpsellProduct from '../PDPUpSellProduct';
import PDPExtraOptionSelector from '../PDPExtraOptionSelector';
import PDPSelectUpholsteryDecideLater from '../PDPSelectUpholstery/PDPSelectUpholsteryDecideLater';
import PDPSelectUpholsteryPlaceholder from '../PDPSelectUpholstery/PDPSelectUpholsteryPlaceholder';
import PDPChooseYourOptionsPlaceholder from './PDPChooseYourOptionsPlaceholder';
const getTabContentId = selectedTab => {
  if (selectedTab === customItem.id) {
    return customItem.contentId;
  }
  if (selectedTab === readyToShipItem.id) {
    return readyToShipItem.contentId;
  }
  if (decideLaterItem.id) {
    return decideLaterItem.contentId;
  }
  return '';
};
const IS_PDP_IMAGE_TEXT_DROPDOWN_OPTION_ENABLED = getEnvValue('NEXT_PUBLIC_IS_PDP_IMAGE_TEXT_DROPDOWN_OPTION_ENABLED') === 'true';
const PDPChooseYourOptionsUIInner = t0 => {
  const $ = _c(45);
  const {
    pdpIsModularBYOProduct,
    isDecideLaterTab,
    isEditOrder: t1,
    isFFG: t2,
    isRTSTab: t3,
    loading: t4,
    mode: t5,
    options: t6,
    onMoreMaterialsClick,
    productId: t7,
    selectionValidity: t8,
    slug: t9,
    upholsteryOptionId,
    optionSelector: t10,
    setMarxentSelectedFabric
  } = t0;
  const isEditOrder = t1 === undefined ? false : t1;
  const isFFG = t2 === undefined ? true : t2;
  const isRTSTab = t3 === undefined ? false : t3;
  const loading = t4 === undefined ? false : t4;
  const mode = t5 === undefined ? "pdp" : t5;
  let t11;
  if ($[0] !== t6) {
    t11 = t6 === undefined ? [] : t6;
    $[0] = t6;
    $[1] = t11;
  } else {
    t11 = $[1];
  }
  const options = t11;
  const productId = t7 === undefined ? null : t7;
  const selectionValidity = t8 === undefined ? "" : t8;
  const slug = t9 === undefined ? null : t9;
  const optionSelector = t10 === undefined ? "" : t10;
  const {
    isMobile
  } = useScreen();
  const pdpSelectedCustomizerTab = usePdpSelectedCustomizerTab();
  if (loading) {
    let t12;
    if ($[2] !== pdpSelectedCustomizerTab) {
      t12 = getTabContentId(pdpSelectedCustomizerTab);
      $[2] = pdpSelectedCustomizerTab;
      $[3] = t12;
    } else {
      t12 = $[3];
    }
    const t13 = mode === "pdp";
    let t14;
    if ($[4] !== t13) {
      t14 = classNames("mt-8 mx-0 mb-0 relative w-full last:[border-bottom:0] last:pb-0", {
        "mt-0 mx-0 mb-4": t13
      });
      $[4] = t13;
      $[5] = t14;
    } else {
      t14 = $[5];
    }
    let t15;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t15 = <PDPSelectUpholsteryPlaceholder />;
      $[6] = t15;
    } else {
      t15 = $[6];
    }
    let t16;
    if ($[7] !== t14) {
      t16 = <div className={t14}>{t15}</div>;
      $[7] = t14;
      $[8] = t16;
    } else {
      t16 = $[8];
    }
    let t17;
    if ($[9] !== t12 || $[10] !== t16) {
      t17 = <div className="flex w-full flex-col relative z-[3]" id={t12}>{t16}</div>;
      $[9] = t12;
      $[10] = t16;
      $[11] = t17;
    } else {
      t17 = $[11];
    }
    return t17;
  }
  let t12;
  if ($[12] !== loading || $[13] !== options || $[14] !== upholsteryOptionId) {
    t12 = !loading && upholsteryOptionId && options?.length ? options.find(opt => opt.id === upholsteryOptionId) : null;
    $[12] = loading;
    $[13] = options;
    $[14] = upholsteryOptionId;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  const upholsteryOptionValue = t12;
  const t13 = optionSelector || "";
  let t14;
  if ($[16] !== t13) {
    t14 = t13.toLowerCase();
    $[16] = t13;
    $[17] = t14;
  } else {
    t14 = $[17];
  }
  const isUpholsterySelectorDropdownMode = t14 === "dropdown";
  let t15;
  if ($[18] !== pdpSelectedCustomizerTab) {
    t15 = getTabContentId(pdpSelectedCustomizerTab);
    $[18] = pdpSelectedCustomizerTab;
    $[19] = t15;
  } else {
    t15 = $[19];
  }
  let t16;
  if ($[20] !== isDecideLaterTab || $[21] !== isEditOrder || $[22] !== isFFG || $[23] !== isMobile || $[24] !== isUpholsterySelectorDropdownMode || $[25] !== loading || $[26] !== mode || $[27] !== onMoreMaterialsClick || $[28] !== optionSelector || $[29] !== options || $[30] !== pdpIsModularBYOProduct || $[31] !== productId || $[32] !== setMarxentSelectedFabric || $[33] !== slug || $[34] !== upholsteryOptionId || $[35] !== upholsteryOptionValue) {
    t16 = !loading && options?.length ? <>{isUpholsterySelectorDropdownMode && <div className={classNames("mt-8 mx-0 mb-0 relative w-full last:[border-bottom:0] last:pb-0", {
        "mt-0 mx-0 mb-4": mode === "quickview",
        "!z-[999]": mode !== "pdp"
      })} key="upholstery-selector-dropdown"><PDPTextDropdownOptionGroup optionId={upholsteryOptionValue?.id} isEditOrder={isEditOrder} slug={slug} /></div>}{isDecideLaterTab && !isUpholsterySelectorDropdownMode ? !isMobile && <PDPSelectUpholsteryDecideLater /> : upholsteryOptionValue && !isUpholsterySelectorDropdownMode ? <div className={classNames("mt-8 mx-0 mb-0 relative w-full last:[border-bottom:0] last:pb-0", "PDPChooseYourOptionsUI__section--select-upholstery-wrapper", {
        "mt-0 mx-0 mb-4": mode === "quickview"
      })} key={upholsteryOptionValue.id}><PDPSelectUpholsteryInner isEditOrder={isEditOrder} mode={mode} optionId={upholsteryOptionValue.id} onMoreMaterialsClick={onMoreMaterialsClick} productId={productId} slug={slug} setMarxentSelectedFabric={setMarxentSelectedFabric} /></div> : <div className="PDPChooseYourOptionsUI__section--select-upholstery-wrapper-filler" />}<div className="PDPChooseYourOptionsUI__option-sections-wrapper">{options.map(option => {
          if (isFFG && option.id === 19 || option.id === upholsteryOptionId || pdpIsModularBYOProduct && ORIENTATION_TYPE_OPTION_IDS.includes(option.id) || (option.id !== 17 || option.id !== 18) && isEditOrder) {
            return null;
          }
          if (IS_PDP_IMAGE_TEXT_DROPDOWN_OPTION_ENABLED && IMAGE_TEXT_DROPDOWN_OPTION_IDS.includes(option.id)) {
            return <div className={classNames("mt-8 mx-0 mb-0 relative w-full last:[border-bottom:0] last:pb-0", {
              "mt-0 mx-0 mb-4": mode === "quickview",
              "!z-[999]": mode !== "pdp"
            })} key={option.id}><PDPImageTextDropdownOption optionId={option.id} /></div>;
          }
          if ((optionSelector || "").toLowerCase() === "dropdown") {
            return <div className={classNames("mt-8 mx-0 mb-0 relative w-full last:[border-bottom:0] last:pb-0", {
              "mt-0 mx-0 mb-4": mode === "quickview",
              "!z-[999]": mode !== "pdp"
            })} key={option.id}><PDPTextDropdownOptionGroup optionId={option.id} /></div>;
          }
          switch (option.optionDisplayType) {
            case "ImageSelector":
              {
                return <div className={classNames("mt-8 mx-0 mb-0 relative w-full last:[border-bottom:0] last:pb-0", {
                  "mt-0 mx-0 mb-4": mode === "pdp"
                })} key={option.id}><PDPImageSelector isEditOrder={isEditOrder} optionId={option.id} /></div>;
              }
            case "TextSelector":
            case "ImageAndTextSelector":
              {
                return <div className={classNames("mt-8 mx-0 mb-0 relative w-full last:[border-bottom:0] last:pb-0", {
                  "mt-0 mx-0 mb-4": mode === "pdp"
                })} key={option.id}><PDPImageAndTextSelector isEditOrder={isEditOrder} imageOrTextVariant={option.optionDisplayType === "TextSelector" ? "textOnly" : "regular"} mode={mode} optionId={option.id} productId={productId} variant="regular" /></div>;
              }
            case "PDPFullWidthImageAndTextSelector":
              {
                return <div className={classNames("mt-8 mx-0 mb-0 relative w-full last:[border-bottom:0] last:pb-0", {
                  "mt-0 mx-0 mb-4": mode === "pdp"
                })} key={option.id}><PDPImageAndTextSelector isEditOrder={isEditOrder} optionId={option.id} productId={productId} variant="fullWidth" /></div>;
              }
            case "TextDropdownSelector":
              {
                return <div className={classNames("mt-8 mx-0 mb-0 relative w-full last:[border-bottom:0] last:pb-0", {
                  "mt-0 mx-0 mb-4": mode === "quickview",
                  "!z-[999]": mode !== "pdp"
                })} key={option.id}><PDPTextDropdownOptionGroup key={`${option.id}--PDPTextDropdownOptionGroup`} optionId={option.id} /></div>;
              }
            case "UpsellSelector":
              {
                return <PDPUpsellProduct productId={productId} slug={slug} />;
              }
            case "ExtraOptionSelector":
              {
                return <PDPExtraOptionSelector key={`${option.id}--PDPExtraOptionSelector`} />;
              }
            default:
              {
                return <div className={classNames("mt-8 mx-0 mb-0 relative w-full last:[border-bottom:0] last:pb-0", {
                  "mt-0 mx-0 mb-4": mode === "quickview"
                })} key={option.id}><PDPTextDropdownOptionGroup optionId={option.id} /></div>;
              }
          }
        })}</div></> : <><div className="PDPChooseYourOptionsUI__PDPSelectUpholsteryDecideLater-filler" /><div className="PDPChooseYourOptionsUI__PDPSelectUpholsteryDecideLater-filler" /></>;
    $[20] = isDecideLaterTab;
    $[21] = isEditOrder;
    $[22] = isFFG;
    $[23] = isMobile;
    $[24] = isUpholsterySelectorDropdownMode;
    $[25] = loading;
    $[26] = mode;
    $[27] = onMoreMaterialsClick;
    $[28] = optionSelector;
    $[29] = options;
    $[30] = pdpIsModularBYOProduct;
    $[31] = productId;
    $[32] = setMarxentSelectedFabric;
    $[33] = slug;
    $[34] = upholsteryOptionId;
    $[35] = upholsteryOptionValue;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== isRTSTab || $[38] !== loading || $[39] !== selectionValidity) {
    t17 = !loading && isRTSTab && selectionValidity ? <PDPSelectionAlert selectionValidity={selectionValidity} /> : <div className="PDPChooseYourOptionsUI__PDPSelectionAlert-filler" />;
    $[37] = isRTSTab;
    $[38] = loading;
    $[39] = selectionValidity;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  let t18;
  if ($[41] !== t15 || $[42] !== t16 || $[43] !== t17) {
    t18 = <div className="flex w-full flex-col relative z-[3]" id={t15}>{t16}{t17}</div>;
    $[41] = t15;
    $[42] = t16;
    $[43] = t17;
    $[44] = t18;
  } else {
    t18 = $[44];
  }
  return t18;
};
PDPChooseYourOptionsUIInner.propTypes = {
  isDecideLaterTab: PropTypes.bool,
  isEditOrder: PropTypes.bool,
  isFFG: PropTypes.bool,
  isRTSTab: PropTypes.bool,
  loading: PropTypes.bool,
  mode: PropTypes.oneOf(['pdp', 'quickview']),
  onMoreMaterialsClick: PropTypes.func,
  options: PropTypes.arrayOf(PropTypes.object),
  optionSelector: PropTypes.string,
  pdpIsModularBYOProduct: PropTypes.bool,
  productId: PropTypes.number,
  selectionValidity: PropTypes.string,
  setMarxentSelectedFabric: PropTypes.func,
  slug: PropTypes.string,
  upholsteryOptionId: PropTypes.number
};
const PDPChooseYourOptionsUI = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <PDPChooseYourOptionsPlaceholder />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <SuspenseWithLoader fallback={t0}><PDPChooseYourOptionsUIInner {...props} /></SuspenseWithLoader>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default PDPChooseYourOptionsUI;